import React, { useState, useEffect } from 'react';
import { textAPI } from 'api';
import { getSafeString } from 'utils/getSafeString';
import Pages from 'pages';
import { useChat } from 'context/ChatContext';
import { useApp } from 'context/AppContext';
import { Header } from 'components/Header/Header';
import { Menu } from 'components/Menu/Menu';
import { LandscapeScreen } from 'components/LandscapeScreen/LandscapeScreen';
import AddToHomeScreen from 'components/AddToHomeScreen/AddToHomeScreen';
import { Statistic } from '@b3w/react-statistic';
import { Component } from './App.styled';
import PPPortal from '../components/PPPortal/PPPortal';

const App = () => {
    const { data } = textAPI.useGetPolicyQuery();
    const content = getSafeString(data?.content);

    const { events } = useChat();
    const { updateMessageCount } = useApp();

    const [isLandscapeOrientation, setLandscapeOrientation] = useState(false);

    window.addEventListener('orientationchange', () => {
        if (window.screen.orientation.type === 'landscape-primary') {
            setLandscapeOrientation(true);
        } else {
            setLandscapeOrientation(false);
        }
    });

    useEffect(() => {
        if (events.length) {
            updateMessageCount();
        }
    }, [events]);

    return (
        <Component id="app">
            { isLandscapeOrientation && <LandscapeScreen /> }
            <Statistic path="/flirt/referer/statistic" from timeoutMinutes={1} />
            <Header />
            <Menu />
            <Pages />
            <PPPortal policyText={content} />
            <AddToHomeScreen />
        </Component>
    );
};

export default App;
